import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import classNames from 'classnames';
import moment from 'moment';
import Sound from 'react-sound';
import Alert from 'react-s-alert';
import Dialog from "material-ui/Dialog";
import { delay } from 'lodash';
import { 
    PatientRecordMoemtaryDataListAction,
    SavePatientRecordMomentaryDataAction,
    moentaryValueStaticArrayAction,
    isRecordMomentaryStart,
    resetMomentaryTimer, 
    resetCustomMomentaryArray, 
    resetMomentaryCount, 
    resetMomentaryObservationTimer,
    customSecondsElapsedForMomentary,
    customSecondsElapsedForMomentaryObservation
 } from '../../actions/BehaviourDataActions';
import Loader from '../../../../../../../../img/loader.gif';
import { SubmitButtonModal, SubmitButtonModalDisabled  } from '../../../../../../../../components/buttons';
import RecordMomentaryDataViewModal from './RecordMoemtaryDataViewModal';
import Beep from '../../../../../../../../static/Sound/beep-07.mp3';
import TimerForMomentary from '../TimerForMomentary';
import TimerForMomentaryObservation from '../TimerForMomentaryObservation';
import GlobalVariables, { alertConfirmation } from '../../../../../../../../actions/utilAction';
import MomentaryTimeSampleGraphModal from "../../MomentaryTimeSampleGraphModal";


class RecordMomentary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId: props.patientId ? props.patientId : null,
            creadteDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
            MomentaryArray: props.customMomentaryArray,
            isStart: props.isStart,
            isSave: props.isSave,
            secondsElapsed: props.secondsElapsed,
            incrementer: props.incrementer,
            Id: [],
            todayRecordMomentaryDataViewModal: false,
            beepSound: false,
            openDataCollectionModal: false,
            momentaryGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
            recordingTypeName:'MOMENTARY TIME SAMPLE'
        }
    }

    renderLoading() {
        if (this.state.isLoading) {
            return (
                <div className="full_loader">
                    <div className="circle_loader page_loader">
                        <img src={Loader} alt="" />
                    </div>
                </div>
            );
        }
    }

    componentWillMount = () => {
            this.props.PatientRecordMoemtaryDataListAction(this.state.patientId)
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.recordMomentaryList.data !== undefined) {
            let Id = this.state.Id
            let patientBehaviorsReductionData = nextProps.recordMomentaryList.data.PatientBehaviorsReductionData;
            patientBehaviorsReductionData.map((obj, index) => {
                return Id[index] = obj.id;
            })
            this.setState({
                Id: Id
            })
        }

        if(this.props.intervalCount !== nextProps.intervalCount) {
            if(nextProps.intervalCount !== 1) {
                this.setState({
                    openDataCollectionModal: true
                })
                clearInterval(this.state.incrementer[0]);
                clearInterval(this.props.newIncrementer[0]);
            }
        }
    }

    alertRaiser = ()=>{
        Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
              displayComponent: true,
              handleButtonClick: ()=>this.handleStart(),
              // id: obj.id,
            },
          });
    }

    momentaryClickHandler = (type, index) => {
        if (type === "Minus" && this.props.customMomentaryArray[index] !== undefined && this.props.customMomentaryArray[index] > 0) {
            this.props.moentaryValueStaticArrayAction("Minus", index)
        } else if (type === "Plus" && (this.props.customMomentaryArray[index] === undefined || this.props.customMomentaryArray[index] === 0)) {
            this.props.moentaryValueStaticArrayAction("Plus", index)
        }
    }

    callAlertStartTimer  = ()=>{
        for (const ele of this.props.recordMomentaryList.data.PatientBehaviorsReductionData) {
            if (ele.isDataCollectedInDailySummaryData) {
                this.alertRaiser();
                return; // Exits the outer function
            }
        }
        this.handleStart(); // Only runs if the condition above was not met
    }

    handleClose = () => {
        this.setState({
            todayRecordMomentaryDataViewModal: false,
            openDataCollectionModal: false,
            momentaryGraphModalOpen:false,
            modalTitle:'',
            behaviorsReductionId:-1,
        })
    }

    onGraphHandler(e,obj){
        e.preventDefault();
        this.setState({
            momentaryGraphModalOpen: true,
            modalTitle: obj.behaviorName,
            behaviorsReductionId: obj.id,
        })
    }

    todayRecordMomentaryDataView = () => {
        this.setState({
            todayRecordMomentaryDataViewModal: true
        })

    }

    handleStart = () => {
        Alert.closeAll()
        this.props.isRecordMomentaryStart(true,false)
        let isStart = this.state.isStart
        isStart = true
        this.setState({
            isStart: isStart,
            beepSound: true
        });
    }

    handleResume = () => {
        this.props.isRecordMomentaryStart(true,false);
        this.props.customSecondsElapsedForMomentary("mount");
        this.props.customSecondsElapsedForMomentaryObservation("mount");
        let isStart = this.state.isStart;
        isStart = true
        this.setState({
            isStart: isStart,
            isSave: false,
            beepSound: true
        });
    }

    handleStop = () => {
        let isStart = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        isStart = false
        isSave = true
        this.setState({
            isStart: isStart,
            isSave: isSave,
            secondsElapsed: counterData,
            beepSound: false
        }, () => { 
                clearInterval(this.state.incrementer[0]), 
                clearInterval(this.props.newIncrementer[0]),
                clearInterval(this.props.observationIncrementerOne[0]),
                clearInterval(this.props.observationIncrementerTwo[0]),
                this.props.isRecordMomentaryStart(false,this.state.isSave)
        });
    }

    handleCancel = () => {
        Alert.closeAll();
        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        clikcedData = false
        isSave = false
        counterData = 0;
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            beepSound: false,
            MomentaryArray: []
        }, () => {
            clearInterval(this.state.incrementer[0]),
            clearInterval(this.props.newIncrementer[0]),
            clearInterval(this.props.observationIncrementerOne[0]),
            clearInterval(this.props.observationIncrementerTwo[0]),
            this.props.resetMomentaryTimer(), 
            this.props.resetMomentaryObservationTimer(), 
            this.props.isRecordMomentaryStart(false,this.state.isSave), 
            this.props.resetMomentaryCount(), 
            this.props.resetCustomMomentaryArray()
        })
    }


    handleCancelConfirmation = () => {
        alertConfirmation('Are you sure you want to clear Momentary details?', {
            customFields: {
                displayComponent: true,
                handleButtonClick: () => this.handleCancel(),
            }
        });
    }

    handleSave = async () => {
        let minutes = Math.floor(this.props.secondsElapsed / 60);
        let seconds = Math.floor(this.props.secondsElapsed % 60);

        let observationMinutes =  Math.floor(this.props.observationSecondsElapsed / 60);  
        let observationSeconds =  Math.floor(this.props.observationSecondsElapsed % 60);  

        if (seconds < 10) {
            seconds = `0${seconds}`
        }

        if (observationSeconds < 10) {
            observationSeconds = `0${observationSeconds}`
        }

        let duration = minutes + "." + seconds;
        let observationDuration = observationMinutes + "." + observationSeconds;
        let finalData = [];
        this.state.Id.map((id, index) => {
            let patientRecordMomentaryDataDetailsModel = {
                "recordMomentaryDataDetailId": 0,
                "recordMomentaryDataId": 0,
                "behaviorsReductionId": id,
                "value": this.props.customMomentaryArray[index],
                "timeOfIntervals": duration
            }
            finalData.push(patientRecordMomentaryDataDetailsModel)
        })

        let clikcedData = this.state.isStart
        let isSave = this.state.isSave
        let counterData = this.state.secondsElapsed
        counterData = 0;
        clikcedData = false
        isSave = false
        this.setState({
            isStart: clikcedData,
            isSave: isSave,
            secondsElapsed: counterData,
            MomentaryArray: [],
            openDataCollectionModal: false,
            todayRecordMomentaryDataViewModal: false,
        }, () => { 
                clearInterval(this.state.incrementer[0]), 
                clearInterval(this.props.newIncrementer[0])
                // this.props.resetMomentaryTimer(),
                // this.props.resetMomentaryObservationTimer(), 
                // this.props.resetMomentaryCount(), 
                this.props.resetCustomMomentaryArray() 
        });

        let authData = {
            "id": 0,
            "patientId": this.state.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": this.state.creadteDate,
            "interval": this.props.intervalCount - 1,
            "duration": observationDuration,
            "patientRecordMomentaryDataDetailsModel": finalData
        }
        await this.props.SavePatientRecordMomentaryDataAction(authData);
        this.handleStart(); 
        delay(()=> this.props.PatientRecordMoemtaryDataListAction(this.state.patientId),200)     
    }

    renderData = (dataList,isEnableGraph) => {
        let PatientRecordMomentaryData = dataList || [];
        if (!PatientRecordMomentaryData.length) {
            return (
                <tr>
                    <td colSpan='3'>
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientRecordMomentaryData.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>
                        {Obj.behaviorName}
                    </td>
                    <td>
                        {Obj.description}
                    </td>
                    {
                        !isEnableGraph &&
                        (
                        <td>
                            <div className='row'>
                                <div className="col-sm-1"> </div>
                                <div className="col-sm-3">
                                    {this.state.isSave === false && <button
                                        name={`momentaryMinus${index}`}
                                        className="tableadd"
                                        title="Minus"
                                        type="button"
                                        onClick={() => this.momentaryClickHandler("Minus", index)}
                                    >
                                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                                    </button>}
                                </div>
                                <div className="col-sm-3">{this.props.customMomentaryArray[index] || 0}</div>
                                <div className="col-sm-3">
                                    {this.state.isSave === false && <button
                                        name={`momentaryPlus${index}`}
                                        className="tableadd"
                                        title="Plus"
                                        type="button"
                                        onClick={() => this.momentaryClickHandler("Plus", index)}
                                    >
                                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                                    </button>}
                                </div>
                                <div className="col-sm-2"> </div>
                            </div>
                        </td>
                        )
                    }
                    {
                        isEnableGraph && (
                            <td>
                                {/* {(this.state.targetType && this.state.targetType[index])?( */}
                                    <button type="button" onClick={(e) => this.onGraphHandler(e,Obj)} title="Graph" className="tbactionbtn bluefont"><i className="fa fa-line-chart" aria-hidden="true"></i></button>
                                {/* ):''} */}
                            </td>
                        )
                    }
                </tr>
            )
        })
    }

    renderRecordMomentary = (isEnableGraph) => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { recordMomentaryList } = this.props;
        let PatientRecordMoentaryList = (recordMomentaryList && recordMomentaryList.data) || [];
        return (
            <div className="table-responsive mt-15">
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="40%">Momentary</th>
                            {
                                !isEnableGraph && <th width="40%">Operational Definition</th> 
                            }
                            {
                                !isEnableGraph && <th width="20%"></th>
                            }
                            {
                                isEnableGraph && <th width="40%">Operational Definition</th>
                            }
                            {
                                isEnableGraph && <th width="20%">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData(PatientRecordMoentaryList.PatientBehaviorsReductionData,isEnableGraph)}
                    </tbody>
                </table>
            </div>
        )
    }


    render() {
        const { handleSubmit } = this.props;
        let customTimeForMomentary = this.props.customTimeForMomentary;
        customTimeForMomentary = customTimeForMomentary * 60 * this.props.intervalCount;
        let submitButton = this.props.loading ?
            <SubmitButtonModalDisabled label="Loading" /> :
            <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.handleSave.bind(this))} />;
        const actions = [submitButton];
        return (
            <div>
                {this.renderLoading()}
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="row">
                            <div className="col-3 col-sm-3 col-md-3">
                                {(this.state.isStart === false && this.state.isSave === false) && this.props.addPermissionBehavior && 
                                    <RaisedButton
                                        label="START"
                                        className='startButton'
                                        primary={true}
                                        onTouchTap={() => this.callAlertStartTimer()}  />
                                }
                                {(this.state.isStart === true && this.state.isSave === false) &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="STOP"
                                                className='stopButton'
                                                primary={true}
                                                onTouchTap={() => this.handleStop()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CLEAR"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                                {this.state.isSave === true &&
                                    <div>
                                        <span>
                                            <RaisedButton
                                                label="RESUME"
                                                primary={true}
                                                onTouchTap={() => this.handleResume()} />
                                        </span>
                                        <span style={{ marginLeft: '20px' }}>
                                            <RaisedButton
                                                label="CLEAR"
                                                className='cancelButton'
                                                primary={true}
                                                onTouchTap={() => this.handleCancelConfirmation()} />
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>#Interval</b>
                                <div>{this.props.intervalCount - 1}</div>
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>Elapsed</b>
                                <div>{this.state.isStart || this.state.isSave ? <TimerForMomentary isSave={this.state.isSave}/> : '0:00'}</div>
                            </div>
                            <div className="col-2 col-sm-2 col-md-2">
                                <b>Observation</b>
                                <div>{this.state.isStart || this.state.isSave ? <TimerForMomentaryObservation isSave={this.state.isSave} /> : '0:00'}</div>
                            </div>
                            <div className="col-3 col-sm-3 col-md-3 btn_rt reset-btn">
                                <RaisedButton
                                    className="ml_15"
                                    onClick={() => this.todayRecordMomentaryDataView()}
                                    label="Today's Momentary Data"
                                    primary={true}>
                                </RaisedButton>
                            </div>
                        </div>
                        {
                            this.state.openDataCollectionModal && <Dialog
                                className="custom_modal"
                                title="Collect Data"
                                modal={false}
                                open={this.state.openDataCollectionModal}
                                actions={actions}
                                autoScrollBodyContent={true}
                            >
                                {this.renderRecordMomentary()}
                            </Dialog>
                        }
                        {
                            this.state.todayRecordMomentaryDataViewModal && <RecordMomentaryDataViewModal
                                patientId={this.state.patientId}
                                creadtedDate={moment().format('YYYY-MM-DDTHH:mm:ss')}
                                uuid={this.props.uuid}
                                closeDialog={() => this.handleClose()}
                                updatePermissionBehavior = {this.props.updatePermissionBehavior}
                                deletePermissionBehavior =  {this.props.deletePermissionBehavior}
                            />
                        }
                        {
                            (this.props.secondsElapsed == 0 || (this.props.secondsElapsed == (customTimeForMomentary - 1))) && this.state.beepSound ?
                                <Sound
                                    url={Beep}
                                    playStatus={Sound.status.PLAYING}
                                    playFromPosition={0}
                                />
                                : ''
                        }
                    </div>
                </div>
                {this.renderRecordMomentary(true)}
                {
                    this.state.momentaryGraphModalOpen && <MomentaryTimeSampleGraphModal
                        patientId={this.state.patientId}
                        closeDialog={() => this.handleClose()}
                        recordingTypeName={this.state.recordingTypeName}
                        behaviorsReductionId={this.state.behaviorsReductionId}
                        modalTitle={this.state.modalTitle}
                    />
                }
            </div>
        )
    }
}

RecordMomentary = reduxForm({
    form: 'RecordMomentaryForm',
    enableReinitialize: true,
})(RecordMomentary);

function mapStateToProps(state) {
    return {
        loading: state.patientRecordMomentaryCustomReducer.loading,
        recordMomentaryList: state.patientRecordMomentaryCustomReducer.momentaryDataList !== null ? state.patientRecordMomentaryCustomReducer.momentaryDataList : [],
        uuid: state.patientSkillAcqActiveProgram.uuid,

        isStart: state.patientRecordMomentaryCustomReducer.isStart,
        isSave: state.patientRecordMomentaryCustomReducer.isSave,
        secondsElapsed: state.patientRecordMomentaryCustomReducer.secondsElapsed,
        observationSecondsElapsed: state.patientRecordMomentaryCustomReducer.observationSecondsElapsed,
        incrementer: state.patientRecordMomentaryCustomReducer.incrementer,
        newIncrementer: state.patientRecordMomentaryCustomReducer.newIncrementer,
        intervalCount: state.patientRecordMomentaryCustomReducer.intervalCount,
        customTimeForMomentary: state.patientRecordMomentaryCustomReducer.recordMomentaryCustomTime !== null && state.patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data ? state.patientRecordMomentaryCustomReducer.recordMomentaryCustomTime.data.momentaryIntervalDuration : GlobalVariables.IntervalDuration,
        customMomentaryArray: Object.assign({},state.patientRecordMomentaryCustomReducer.customMomentaryArray),
        observationIncrementerOne: state.patientRecordMomentaryCustomReducer.observationIncrementerOne,
        observationIncrementerTwo: state.patientRecordMomentaryCustomReducer.observationIncrementerTwo
    }
}

export default connect(mapStateToProps, { 
    PatientRecordMoemtaryDataListAction,
    SavePatientRecordMomentaryDataAction, 
    moentaryValueStaticArrayAction,
    isRecordMomentaryStart, 
    resetMomentaryTimer,
    resetMomentaryCount,
    resetCustomMomentaryArray,
    resetMomentaryObservationTimer,
    customSecondsElapsedForMomentary,
    customSecondsElapsedForMomentaryObservation
 })(RecordMomentary);



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordMomentary/RecordMomentary.js